export const BROADCAST_ACTION_METADATA = Object.freeze({ broadcast: true });

export const USER_ACTION_METADATA = Object.freeze({ user: true });

export const ANALYTICS_ACTION_METADATA = Object.freeze({ analytics: true });
